// composables/useInsiderSearchTracking.ts

/* =======================
 * Types
 * ======================= */

export interface IProductFacet {
  label: string
  field: string
  values: string[]
}



export interface IInsiderProduct {
  id: string
  groupCode: string
  query: string

  price: number
  convertedPrice: number
  currency: string
  preferredCurrency: string

  clickPosition: number
  searchPosition: number
  Position: number
  quantity: number

  resultCount: number
  itemsPerPage: number
  totalPages: number
  currentPage?: number

  facets?: IProductFacet[]
  sorting?: string

  searchSessionId?: string
}

export interface IGlobalParam {
  referrer: string
  source?: string
  platform?: 'desktop-web' | 'mobile-web' | 'ios' | 'android'
  campId?: number
  variationId?: number
  orderId?: number
  allPurchasedProducts?: IInsiderProduct[]
  eventType: string
  integrationType: 'web' | 'app'
  createdAt: string,
  SearchSessionId?: string,
  CurrentPage?: number,
}

export interface IInsiderSearchEventPayload extends IGlobalParam {
  product?: IInsiderProduct
  userId?: string
}

/* =======================
 * Composable
 * ======================= */

export const useInsiderSearchTracking = () => {

  const config = useRuntimeConfig()

  const isClient = () => process.client

  const getSingaporeRFC3339 = (): string => {
    const now = new Date()

    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Asia/Singapore',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    })
      .formatToParts(now)
      .reduce((acc, part) => {
        if (part.type !== 'literal') {
          acc[part.type] = part.value
        }
        return acc
      }, {} as Record<string, string>)

    return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}:${parts.second}+08:00`
  }


  /**
   * Base payload builder
   */
  const buildBasePayload = (
    params: Omit<IGlobalParam, 'createdAt'> & {
      createdAt?: string
    }
  ): IGlobalParam | null => {
    if (!isClient()) return null

    return {
      ...params,
      createdAt: getSingaporeRFC3339()
    }
  }

  /**
   * 🔹 Search / Click / Add-to-cart
   */
  const trackInsiderSearchEvent = (
    params: {
      referrer: string
      source: string
      platform: IGlobalParam['platform']
      campId?: number
      variationId?: number
      eventType: string
      integrationType: IGlobalParam['integrationType']
      product?: IInsiderProduct
      createdAt?: string
      userId?: string,
      SearchSessionId?: string,
      CurrentPage?: number,
    }
  ): IInsiderSearchEventPayload | null => {
    const base = buildBasePayload(params)
    if (!base) return null

    return {
      ...base,
      ...(params.product ? { product: params.product } : {})
    }
  }

  const getUUidInsiderSearch = (uid: string) => {
    if (!uid && process.client) {
      try {
        const spUIDRaw = localStorage.getItem('spUID')
        const spUIDData = spUIDRaw ? JSON.parse(spUIDRaw)?.data : null

        uid = spUIDData || 'guest'
      } catch {
        uid = 'guest'
      }
      return uid;
    }
    return uid;
  }

  /* =======================
   * 🔹 CALL INSIDER API
   * ======================= */
  const sendInsiderEvent = async (payload: any) => {
    console.log('------ INSIDER_ENV: ', config.public.INSIDER_ENV);
    console.log('------------ send tracking -------------------', payload.eventType, payload)
    const insiderEnv = config.public.INSIDER_ENV;
    if (insiderEnv != 'production') return;
   // console.log('production envi');
    try {
      const res = await $fetch.raw(
        'https://eurekaevent.api.useinsider.com/api/v1/events',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-auth-token': config.public.INSIDER_AUTH_TOKEN,
            'x-partner-config-key': config.public.INSIDER_PARTNER_KEY
          },
          body: payload
        }
      )

      console.log('✅ status:', res.status)
      console.log('✅ response:', res._data)

    } catch (e: any) {
      console.error('❌ status:', e?.response?.status)
      console.error('❌ error body:', e?.data || e)
    }
  }

  return {
    getSingaporeRFC3339,
    getUUidInsiderSearch,
    trackInsiderSearchEvent,
    sendInsiderEvent
  }
}
